import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { GridColDef } from '@mui/x-data-grid';

import SearchField from '../../common/searchField';
import DataTable from '../../components/DataTable';

import { connectivityDashboardActions } from '../../store/reducers/connectivity-dashboard';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { AssetsRequestPayloadTypes } from '../../store/models/connectivity-dashboard';

import { useLocation, useOutletContext, useParams, useNavigate } from 'react-router-dom';
import { pageActions } from '../../store/reducers/page-actions';
import { palette } from '../../theme/palette';
import { Link } from 'react-router-dom';
import LatestMessagePopup from './latestMessagePopup';

import { ReactComponent as PlcConnected } from '../../assets/connectivitydashboard/plc-connected-icon.svg';
import { ReactComponent as PlcDisconnected } from '../../assets/connectivitydashboard/plc-disconnected-icon.svg';
import { ReactComponent as EmqxConnectedIcon } from '../../assets/connectivitydashboard/emqx-connected-icon.svg';
import { ReactComponent as EmqxDisconnectedIcon } from '../../assets/connectivitydashboard/emqx-disconnected-icon.svg';
import { ReactComponent as DataConnected } from '../../assets/connectivitydashboard/database-connected-icon.svg';
import { ReactComponent as DataDisconnected } from '../../assets/connectivitydashboard/database-disconnected-icon.svg';
import { ReactComponent as FilterIcon } from '../../assets/icons/main/filter-icon.svg';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';

import { convertUTCtoLocal } from '../../utils/time-converter';
import { lighten, useTheme } from '@mui/material';
import get from 'lodash/get';
import IconButton from '@mui/material/IconButton';
import OntologySelector from '../../common/OntologySelector';

const Styles = {
  container: {
    boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)',
    borderRadius: '18px',
    // height: 'calc(100vh - 182px)'
  },
  paper: {
    margin: 'auto',
    boxShadow: '0px 0px 14px 0px #0000000D',
    borderRadius: '18px',
    border: `1px solid #D9DFED`,
    // height: 'calc(100vh - 182px)',
    overflow: 'hidden',
  },
  header: {
    p: 3,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    boxSizing: 'border-box',
    flexWrap: 'wrap',
    rowGap: 1,
    // height: '87px',
  },
  searchFieldWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
  dataTableWrapper: {
    height: '100%',
    overflow: 'hidden',
  },
  dataTable: {
    '& .MuiDataGrid-virtualScroller': {
      overflow: 'auto',
      overflowY: 'hidden',
      minHeight: 'calc(100vh - 420px)',
      // paddingBottom: '10px',
      height: '100%',
    },
    '&.MuiDataGrid-root': {
      // height:'100%',
      minHeight: 'calc(100vh - 278px)',
    },
    '.MuiDataGrid-columnHeader': {
      height: '60px !important',
    },
    '.MuiDataGrid-columnHeaders': {
      minHeight: '60px !important',
      maxHeight: '60px !important',
      lineHeight: '60px !important',
    },
  },
  closeBtnWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBlock: 4,
    borderTop: '1px solid #D9DFED',
  },
  tableCellText: {
    fontSize: '16px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  connectedIcon: { paddingLeft: '8px' },
  disConnectedIcon: { cursor: 'pointer', paddingLeft: '8px' },
  disabledIcon: { color: '#A8B1C7', paddingLeft: '8px' },
};

interface AssetsLabelTypes {
  all: string;
  connected: string;
  disconnected: string;
}

const assetsLabel: AssetsLabelTypes = {
  all: '',
  connected: 'CONNECTED',
  disconnected: 'DISCONNECTED',
};

const AssetsTable = ({ assets, assetsLoading, assetsPageNumber, assetsTotalCount, ontologyData, ontologies }: any) => {
  const theme = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  const dispatch = useDispatch();
  const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });
  const [searchValue, setSearchValue] = useState('');
  const { onto_manage_id, type } = useParams();
  const { state, pathname } = useLocation();
  const [assetsList, setAssetsList] = useState<any>([]);
  const [popupMsgData, setPopupMsgData] = useState<any>({
    status: false,
    title: '',
    type: '',
    item: {},
    connectivityStatus: '',
  });
  const navigate = useNavigate();

  const [assetsFilterBy, setAssetsFilterBy] = useState<string[]>([]);

  // const [loading, setLoading] = useState(true);
  // const mqttClient = useRef<mqtt.MqttClient | null>(null);
  // const [assetConnections, setAssetConnections] = useState<any>([]);

  // useEffect(() => {
  //   setAssetConnections(assets);
  // }, [assets]);

  const dispatchAssetsRequest = (payload: AssetsRequestPayloadTypes) => {
    dispatch(
      connectivityDashboardActions.getAssetsRequest({
        limit: DEFAULT_PAGE_SIZE,
        page: DEFAULT_PAGE_NUMBER,
        onto_manage_id: Number(onto_manage_id),
        search_item: searchValue,
        connectivity_status: type === 'viewall' ? '' : type,
        filter_by: assetsFilterBy.join(','),
        timestamp: new Date().getTime(),
        ...sortingModel,
        ...payload,
      })
    );
  };

  const onSearch = (value: string) => {
    // setLoading(true);
    dispatchAssetsRequest({ search_item: value });
    setSearchValue(value);
  };

  useEffect(() => {
    if (type) {
      // setLoading(true);
      dispatchAssetsRequest({});
      dispatch(ontologyMasterActions.getOntologyMgmntList(''));
      dispatch(ontologyMasterActions.getOntologyList(''));
    }

    return () => {
      dispatch(connectivityDashboardActions.resetAssetsTable());
    };
  }, [type]);

  const getOntologyData = (ontoId: any) => {
    if (ontologies.length > 0) {
      let tempOntoData: any = [];
      restartTheLoop: while (true) {
        for (const item of ontologies) {
          if (item.onto_manage_id == ontoId) {
            tempOntoData.unshift(item);
            ontoId = item.parent_id;
            continue restartTheLoop;
          }
        }
        break;
      }

      tempOntoData.map((item: any) => {
        let getLevelName = ontologyData.filter((data: any) => {
          return data.id === item.onto_level_number;
        })[0];

        return {
          ...item,
          level_name: getLevelName?.level_name || '',
        };
      });

      return tempOntoData;
    }
    return [];
  };

  useEffect(() => {
    if (assets && assets.length > 0 && ontologies.length) {
      setAssetsList(
        assets.map((item: any) => {
          return {
            ...item,
            ontologyList: getOntologyData(item.onto_manage_id),
          };
        })
      );
    } else {
      setAssetsList([]);
    }
  }, [assets, ontologies]);

  useEffect(() => {
    if (pathname.length) {
      const pathnamesTemp: any = pathname.split('/').filter(Boolean);
      if (pathnamesTemp.length) {
        const pathnamesData: any = pathnamesTemp
          .filter((i: any, index: number) => index != 2 && index != 3)
          .map((item: any, index: number) => {
            if (index == 0) {
              return { route: pathnamesTemp[0], pathName: item.replace('-', ' '), navigate: true };
            } else if (index == 1) {
              return { route: '', pathName: 'Assets', navigate: false };
            } else {
              return { route: '', pathName: type, navigate: false };
            }
          });
        // console.log(pathnamesData, 'pathnamesData');
        dispatch(pageActions.setPagePath(pathnamesData));
        return () => {
          const data: any = [];
          dispatch(pageActions.setPagePath(data));
        };
      }
    }
  }, [pathname]);

  // Polling
  useEffect(() => {
    let assetsInterval: any;
    if (!assetsLoading) {
      assetsInterval = setInterval(() => {
        dispatch(
          connectivityDashboardActions.getAssetsPollingRequest({
            connectivity_status: type === 'viewall' ? '' : type,
            onto_manage_id: Number(onto_manage_id),
            limit: DEFAULT_PAGE_SIZE,
            page: assetsPageNumber,
            search_item: searchValue,
            filter_by: assetsFilterBy.join(','),
            timestamp: new Date().getTime(),
            ...sortingModel,
          })
        );
      }, 60000);
    }

    return () => {
      clearInterval(assetsInterval);
    };
  }, [sortingModel, searchValue, assetsPageNumber, assetsLoading, assetsFilterBy]);

  const connectedIconStyle = { ...Styles.connectedIcon, color: theme.palette.success.main };
  const disconnectedIconStyle = { ...Styles.disConnectedIcon, color: theme.palette.error.main };

  const columnsStatuses: GridColDef[] = [
    {
      field: 'asset_ip',
      headerName: 'Asset IP',
      headerAlign: 'left',
      align: 'left',
      width: 200,
    },
    {
      field: 'asset_name',
      headerName: 'Asset Name',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            onClick={() => {
              dispatch(connectivityDashboardActions.resetAssetsHistoryTable());
            }}
            component={Link}
            to={`/connectivity-dashboard/assets/${onto_manage_id}/${type}/history/${params.row.component_id}`}
            sx={{ ...Styles.tableCellText, textDecoration: 'none', color: palette.primary.main }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'location',
      headerName: 'Location',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      minWidth: 300,
      renderCell: (params: any) => {
        const ontoList =
          params.row.ontologyList && params.row.ontologyList.length
            ? params.row.ontologyList.map((item: any, index: number) =>
              params.row.ontologyList.length > 1 ? (
                index === params.row.ontologyList.length - 1 ? (
                  <span key={item.onto_manage_title}>{item.onto_manage_title} </span>
                ) : (
                  <span key={item.onto_manage_title}>{item.onto_manage_title} / </span>
                )
              ) : (
                <span key={item.onto_manage_title}>{item.onto_manage_title}</span>
              )
            )
            : '';

        return (
          <Box sx={{ textWrap: 'wrap', lineHeight: '1.2', width: '280px' }}>
            <Tooltip title={ontoList} placement='left' arrow>
              <Typography
                component='p'
                sx={{
                  textOverflow: 'ellipsis',
                  fontSize: '16px !important',
                  fontWeight: '400',
                  lineHeight: '1.5',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                {ontoList}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: 'last_connected',
      headerName: 'Last Message Time',
      headerAlign: 'left',
      align: 'left',
      flex: 1,
      minWidth: 180,
      renderCell: (params) => {
        const lastConnected = convertUTCtoLocal(params.value);
        return (
          <Tooltip title={lastConnected} arrow>
            <Typography component='p' sx={Styles.tableCellText}>
              {lastConnected}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'connectivity_status',
      headerName: 'Status',
      headerAlign: 'center',
      align: 'center',
      width: 200,
      renderCell: (params) => {
        const statusContainer = (
          <Box
            sx={{ display: 'flex', marginLeft: '20px', alignItems: 'center', justifyContent: 'center', width: '100%' }}
          >
            {params.row.connectivity_status === 'connected' ? (
              <EmqxConnectedIcon style={{ ...connectedIconStyle, paddingLeft: 0 }} />
            ) : params.row.connectivity_status === 'disconnected' ? (
              <EmqxDisconnectedIcon
                style={{ ...disconnectedIconStyle, padding: 0 }}
                onClick={() =>
                  handleMessagePopupOpen('MQTT Broker Connection', 'Disconnected', params?.row?.connectivity_msg)
                }
              />
            ) : (
              <EmqxConnectedIcon style={{ ...Styles.disabledIcon, padding: 0 }} />
            )}
            {params.row.plc_status === 'connected' ? (
              <PlcConnected style={connectedIconStyle} />
            ) : params.row.plc_status === 'disconnected' ? (
              <PlcDisconnected
                style={disconnectedIconStyle}
                onClick={() => handleMessagePopupOpen('PLC Server Connection', 'Disconnected', params?.row?.plc_msg)}
              />
            ) : (
              <PlcConnected style={Styles.disabledIcon} />
            )}
            {params.row.data_status === 'connected' ? (
              <DataConnected style={connectedIconStyle} />
            ) : params.row.data_status === 'disconnected' ? (
              <DataDisconnected
                style={disconnectedIconStyle}
                onClick={() => handleMessagePopupOpen('Data Server Connection', 'Disconnected', params?.row?.data_msg)}
              />
            ) : (
              <DataConnected style={Styles.disabledIcon} />
            )}
          </Box>
        );
        return statusContainer;
      },
    },
  ];

  const columnsAll: GridColDef[] = [
    {
      field: 'asset_ip',
      headerName: 'Asset IP',
      headerAlign: 'left',
      align: 'left',
      width: 200,
    },
    {
      field: 'asset_name',
      headerName: 'Asset Name',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography
            onClick={() => {
              dispatch(connectivityDashboardActions.resetAssetsHistoryTable());
            }}
            component={Link}
            to={`/connectivity-dashboard/assets/${onto_manage_id}/${type}/history/${params.row.component_id}`}
            sx={{ ...Styles.tableCellText, textDecoration: 'none', color: palette.primary.main }}
          >
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'location',
      headerName: 'Location',
      headerAlign: 'left',
      align: 'left',
      minWidth: 300,
      flex: 1,
      renderCell: (params: any) => {
        const ontoList =
          params.row.ontologyList && params.row.ontologyList.length
            ? params.row.ontologyList.map((item: any, index: number) =>
              params.row.ontologyList.length > 1 ? (
                index === params.row.ontologyList.length - 1 ? (
                  <span key={item.onto_manage_title}>{item.onto_manage_title} </span>
                ) : (
                  <span key={item.onto_manage_title}>{item.onto_manage_title} / </span>
                )
              ) : (
                <span key={item.onto_manage_title}>{item.onto_manage_title}</span>
              )
            )
            : '';

        return (
          <Box sx={{ textWrap: 'wrap', lineHeight: '1.2', width: '280px' }}>
            <Tooltip title={ontoList} placement='left' arrow>
              <Typography
                component='p'
                sx={{
                  textOverflow: 'ellipsis',
                  fontSize: '16px !important',
                  fontWeight: '400',
                  lineHeight: '1.5',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                {ontoList}
              </Typography>
            </Tooltip>
          </Box>
        );
      },
      // renderCell: (params) => (
      //   <Tooltip title={params.value} arrow>
      //     <Typography component='p' sx={Styles.tableCellText}>
      //       {params.value}
      //     </Typography>
      //   </Tooltip>
      // ),
    },
    {
      field: 'last_connected',
      headerName: 'Last Message Time',
      headerAlign: 'left',
      align: 'left',
      minWidth: 180,
      flex: 1,
      renderCell: (params) => {
        const lastConnected = convertUTCtoLocal(params.value);
        return (
          <Tooltip title={lastConnected} arrow>
            <Typography component='p' sx={Styles.tableCellText}>
              {lastConnected}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'connectivity_status',
      headerName: 'Status',
      headerAlign: 'center',
      align: 'center',
      width: 200,
      renderCell: (params) => {
        const statusContainer = (
          <Box
            sx={{ display: 'flex', marginLeft: '20px', alignItems: 'center', justifyContent: 'center', width: '100%' }}
          >
            {params.row.connectivity_status === 'connected' ? (
              <EmqxConnectedIcon style={{ ...connectedIconStyle, paddingLeft: 0 }} />
            ) : params.row.connectivity_status === 'disconnected' ? (
              <EmqxDisconnectedIcon
                style={{ ...disconnectedIconStyle, padding: 0 }}
                onClick={() =>
                  handleMessagePopupOpen('MQTT Broker Connection', 'Disconnected', params?.row?.connectivity_msg)
                }
              />
            ) : (
              <EmqxConnectedIcon style={{ ...Styles.disabledIcon, padding: 0 }} />
            )}
            {params.row.plc_status === 'connected' ? (
              <PlcConnected style={connectedIconStyle} />
            ) : params.row.plc_status === 'disconnected' ? (
              <PlcDisconnected
                style={disconnectedIconStyle}
                onClick={() => handleMessagePopupOpen('PLC Server Connection', 'Disconnected', params?.row?.plc_msg)}
              />
            ) : (
              <PlcConnected style={Styles.disabledIcon} />
            )}
            {params.row.data_status === 'connected' ? (
              <DataConnected style={connectedIconStyle} />
            ) : params.row.data_status === 'disconnected' ? (
              <DataDisconnected
                style={disconnectedIconStyle}
                onClick={() => handleMessagePopupOpen('Data Server Connection', 'Disconnected', params?.row?.data_msg)}
              />
            ) : (
              <DataConnected style={Styles.disabledIcon} />
            )}
          </Box>
        );
        return statusContainer;
      },
      minWidth: 100,
    },
  ];

  const handleMessagePopupOpen = (title: string, type: any, item: any) => {
    setPopupMsgData({ status: true, title: title, type: type, item: item || {} });
  };
  const handleMsgPopupClose = () => {
    setPopupMsgData({ status: false, title: '', type: '', item: {}, connectivityStatus: '' });
  };

  const onAssetsFilterBy = (key: string) => {
    const filterByStatuses = assetsFilterBy.includes(key)
      ? assetsFilterBy.filter((status: string) => status !== key)
      : [...assetsFilterBy, key];

    dispatchAssetsRequest({ filter_by: filterByStatuses.join(',') });

    setAssetsFilterBy(filterByStatuses);
  };

  return (
    <Container maxWidth={false} disableGutters sx={Styles.container}>
      <Box sx={{ mb: 4 }}>
        <OntologySelector
          padding='0'
          ontologyData={ontologyData}
          showLayout={true}
          hideBottomRow={true}
          onOntoFilterChange={({ onto_manage_id }: { onto_manage_id: number }) => {
            dispatchAssetsRequest({
              onto_manage_id: Number(onto_manage_id),
            });
            navigate(`/connectivity-dashboard/assets/${onto_manage_id}/${type}`, {
              replace: true
            })
          }}
          hideLine={true}
          ontoManageId={Number(onto_manage_id)}
        />
      </Box>
      <Paper
        sx={{
          ...Styles.paper,
          border: `1px solid  ${theme.palette.customBorderColor.main}`,
          backgroundColor: themeMode.isLightBG
            ? lighten(theme.palette.background.default, 0.9)
            : lighten(theme.palette.background.default, 0.05),
        }}
      >
        <Box sx={Styles.header}>
          <Box>
            <Typography component='h4' fontSize='18px' color={theme.palette.text.primary}>
              List of <span style={{ textTransform: 'capitalize' }}>{type === 'viewall' ? '' : type}</span> Assets
            </Typography>
          </Box>
          <Box sx={Styles.searchFieldWrapper}>
            {(type === 'viewall' || type === 'disconnected') && (
              <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2 }}>
                <Box sx={{ display: 'flex', columnGap: '12px' }}>
                  <Box sx={{ display: 'flex', columnGap: 1 }}>
                    <FilterIcon stroke='#51648f' />
                    <Typography sx={{ fontSize: '16px', color: palette.disabled.dark }}>Filter By :</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
                    <IconButton sx={{ p: 0 }} onClick={() => onAssetsFilterBy('connectivity_status')}>
                      <EmqxDisconnectedIcon
                        style={{
                          color: assetsFilterBy.includes('connectivity_status') ? palette.error.main : '#A8B1C7',
                        }}
                      />
                    </IconButton>
                    <IconButton sx={{ p: 0 }} onClick={() => onAssetsFilterBy('plc_status')}>
                      <PlcDisconnected
                        style={{ color: assetsFilterBy.includes('plc_status') ? palette.error.main : '#A8B1C7' }}
                      />
                    </IconButton>
                    <IconButton sx={{ p: 0 }} onClick={() => onAssetsFilterBy('data_status')}>
                      <DataDisconnected
                        style={{ color: assetsFilterBy.includes('data_status') ? palette.error.main : '#A8B1C7' }}
                      />
                    </IconButton>
                  </Box>
                </Box>
                <Box sx={{ height: '42px', width: '1px', bgcolor: palette.secondary.main }} />
              </Box>
            )}
            <SearchField
              searchPlaceholder='Search'
              onSearch={onSearch}
              sx={{ '@media (max-width: 768px)': { width: '50%' } }}
            />
          </Box>
        </Box>
        <Box sx={Styles.dataTableWrapper}>
          <DataTable
            columns={type === 'viewall' ? columnsAll : columnsStatuses}
            rows={assetsList}
            loading={assetsLoading}
            tableStyles={Styles.dataTable}
            noRowsOverlay={() => (
              <Stack height='100%' alignItems='center' justifyContent='center'>
                No Assets
              </Stack>
            )}
            isServerPagination
            totalRowCount={assetsTotalCount}
            pageNumber={assetsPageNumber}
            onPagination={(pageSize: number, pageNumber: number) => {
              dispatchAssetsRequest({
                limit: pageSize,
                page: pageNumber,
              });
            }}
            onSorting={(sortModel: { field: string; sort: string }) => {
              dispatchAssetsRequest({
                page: assetsPageNumber,
                ...sortModel,
              });
              setSortingModel(sortModel);
            }}
            otherProps={{
              getRowId: (row: any) => row.component_id,
            }}
          />
        </Box>
      </Paper>
      {popupMsgData.status && (
        <LatestMessagePopup popupMsgData={popupMsgData} handleMsgPopupClose={handleMsgPopupClose} />
      )}
    </Container>
  );
};

const mapStateToProps = (state: any) => ({
  assets: state.connectivityDashboard.assets,
  assetsLoading: state.connectivityDashboard.assetsLoading,
  assetsPageNumber: state.connectivityDashboard.assetsPageNumber,
  assetsTotalCount: state.connectivityDashboard.assetsTotalCount,
  ontologyData: state.ontologyMaster.ontologyData,
  ontologies: state.ontologyMaster.ontologyMgmntData,
});

export default connect(mapStateToProps)(AssetsTable);
